module.exports = "<div class=\"row\" >\n  <div class=\"alert alert-success col-12\" >\n    {{notification.msg}} \n  </div>\n</div>"